import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sessao-quemsomos',
  templateUrl: './sessao-quemsomos.component.html',
  styleUrls: ['./sessao-quemsomos.component.scss']
})
export class SessaoQuemsomosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
